import { Trans } from '@lingui/macro';
import { FixedBottomBarContainer, useIsWithinTailWindBreakpoint } from 'noddi-ui-web';
import { PropsWithChildren } from 'react';

import { NoddiButton } from 'noddi-ui-common';
import HelpScoutChat from '../../../components/BookingFlow/HelpScoutChat';
import { useBookingTimeWindow } from '../bookingStore';
import { SelectedCars } from './SelectedCars';
import { SelectedTimeWindow } from './SelectedTimeWindow';
import { ShoppingCart } from './ShoppingCart';

interface FixedBottomBarProps {
  onNextClicked?: () => void;
  disableNextButton?: boolean;
  hideNextButton?: boolean;
  hideShoppingCart?: boolean;
  showSelectedCars?: boolean;
  showSelectedTimeWindow?: boolean;
  nextButtonLoading?: boolean;
}

export const FixedBookingScreenBottomBar = ({
  onNextClicked,
  disableNextButton,
  hideNextButton,
  hideShoppingCart,
  showSelectedCars,
  showSelectedTimeWindow,
  nextButtonLoading
}: PropsWithChildren<FixedBottomBarProps>) => {
  const selectedTimeWindow = useBookingTimeWindow();
  const isXs = useIsWithinTailWindBreakpoint('xs');

  const showShoppingCart = !hideShoppingCart;

  return (
    <FixedBottomBarContainer>
      <div className='mr-2'>
        {(showShoppingCart || showSelectedCars || showSelectedTimeWindow) && isXs ? (
          <HelpScoutChat size='small' />
        ) : (
          <HelpScoutChat size='medium' />
        )}
      </div>
      <div className='flex w-full items-center justify-between gap-3'>
        {showShoppingCart && isXs && (
          <div>
            <ShoppingCart />
          </div>
        )}
        {showSelectedCars && isXs && (
          <div>
            <SelectedCars />
          </div>
        )}

        {showSelectedTimeWindow && isXs && (
          <div>
            <SelectedTimeWindow selectedTimeWindow={selectedTimeWindow} />
          </div>
        )}

        <div className='ml-auto flex gap-3'>
          {showShoppingCart && !isXs && <ShoppingCart />}
          {showSelectedCars && !isXs && <SelectedCars />}
          {showSelectedTimeWindow && !isXs && <SelectedTimeWindow selectedTimeWindow={selectedTimeWindow} />}

          {!hideNextButton && (
            <NoddiButton
              loading={nextButtonLoading}
              onPress={onNextClicked}
              disabled={disableNextButton}
              endIcon='ArrowRight'
            >
              <Trans>Next</Trans>
            </NoddiButton>
          )}
        </div>
      </div>
    </FixedBottomBarContainer>
  );
};
